import React, {Fragment, useState, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Cord
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab'

// Material-UI Icon
import SaveIcon from '@material-ui/icons/Save'

// Material-UI Element
//import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Custom Component
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'

// Custom Style
// import {redColor, oceanBlueColor, grayColor, blackColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import {viewGeneralRevisionStyle} from '../../styles/jss/components/drawingRegister/viewGeneralRevisionStyle'

// Global Function

// Fetch Data
import {updateDrawingRevision} from '../../dataSource/drawingRegister'


// Custom Style (Typography)
// const InboxTypography = withStyles({
// 	root: {
// 		"fontSize": 12,
// 		"fontWeight": 400,
// 		"color": "red",
// 	},
// }) (Typography)


const useStyles = makeStyles(theme => viewGeneralRevisionStyle(theme))

const ViewGeneralRevision = props => {
	const {drawingRecord, revisionRecord, viewGeneralRevisionDialogHandleClose, setDrawingRefash} = props
	const classes = useStyles()
	const dispatch = useDispatch()

	// State Variable
	const [revisionRecordProperty, setRevisionRecordProperty] = useState(null)
	const [validationErrors, setValidationErrors] = useState({})


	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Confirm dialog contral State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})

	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}

	
	const handleTextChange = event => {
		const {name, value} = event.target
		const res = {...revisionRecordProperty}
		res[name] = value

		setRevisionRecordProperty(res)

		validate(res)
	}


	// Confirm Dialog Contral Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	const updateRevisionConfirmAction = () => {
		if (validate()) {
			confirmDialogHandleOpen({
				dialogTitle: "Update Revision",
				dialogContent: "Are you sure to save change.",
				confirmAction: () => updateRevisionItemAction(),
				cancelAction: updateRevisionCancelAction
			})
		}
	}

	const updateRevisionCancelAction = () => {
		confirmDialogHandleClose()
	}

	const updateRevisionItemAction = () => {
		updateDrawingRevision(drawingRecord.dwg_seq, revisionRecord.rev_seq, revisionRecordProperty).then(res => {
			confirmDialogHandleClose()
				
			if (res.type === "success") {
				setDrawingRefash(res.code)
				
				buildAlert({
					// Alert Type: success, info, warning, error
					type: "success",
					title: "Success Alert",
					content: "The revision record have been updated"
				})

				setTimeout(() => {
					viewGeneralRevisionDialogHandleClose()
				}, 2000)
			}
			else {
				buildAlert({
					// Alert Type: success, info, warning, error
					type: "error",
					title: "Error Alert",
					content: res.message
				})
			}
		}).catch(error => {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "error",
				title: "Error Alert",
				content: error.message
			})
		})
	}


	// Input Validation
	const validate = (fieldValues = revisionRecordProperty) => {
		let temp = {...validationErrors}
	
		if ("rev_no" in fieldValues) {
			temp.rev_no = fieldValues.rev_no ? "" : "This field is required"
		}
	
		setValidationErrors({...temp})

		if (fieldValues == revisionRecordProperty) {
			return Object.values(temp).every(x => x == "")
		}
	}

	
	useEffect(() => {
		setRevisionRecordProperty(revisionRecord)
	}, [])


	return (
		// console.log("Drawing Record | Variable: drawingRecord (viewGeneralRevision.js)"),
		// console.log(drawingRecord),
		
		// console.log("Revision Record | Variable: revisionRecord (viewGeneralRevision.js)"),
		// console.log(revisionRecord),

		// console.log("Revision Record Property | Variable: revisionRecordProperty (viewGeneralRevision.js)"),
		// console.log(revisionRecordProperty),

		// console.log("Revision Record Property | Variable: revisionRecordProperty (viewGeneralRevision.js)"),
		// console.log(revisionRecordProperty),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>
			</div>

			{
				revisionRecordProperty ?
					<Grid container spacing={1} className={classes.fieldGridArea}>
						<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
							<TextField
								id="rev_no"
								name="rev_no"
								label="Revision No."
								required
								fullWidth={true}
								size="small"
								variant="outlined"
								value={revisionRecordProperty.rev_no}
								onChange={handleTextChange}
								InputLabelProps={{
									shrink: true,
								}}
								error={validationErrors.rev_no && validationErrors.rev_no !== "" ? true : false}
								helperText={validationErrors.rev_no}
							/>
						</Grid>
					
						<Grid item xs={12} sm={12} lg={12} className={classes.fieldBtn}>
							<Tooltip title="Save">
								<Fab 
									color="primary"
									size="small"
									onClick={updateRevisionConfirmAction}
									className={classes.toolMenuBtn}
								>
									<SaveIcon />
								</Fab>
							</Tooltip>
						</Grid>
					</Grid>
				: ""
			}
		</Fragment>
	)
}


export default ViewGeneralRevision